import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  loadingToggleAction,
  loginAction,
} from "../../store/actions/AuthActions";
import {
  FaShieldAlt,
  FaClipboardCheck,
  FaGlobe,
  FaBuilding,
  FaTicketAlt,
  FaShip,
  FaBinoculars,
  FaTrain,
} from "react-icons/fa";
import { GiCableStayedBridge } from "react-icons/gi";

//
import loginbg from "../../images/bg-1.jpg";
import logofull from "../../images/tdcp.png";
import { LoginApi } from "../../APIS";

function Login(props) {
  const [email, setEmail] = useState([]);
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [step, setStep] = useState(1);
  const [password, setPassword] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();

  const tabs = [
    { name: "Super Admin", icon: <FaShieldAlt /> },
    { name: "Inspection App", icon: <FaClipboardCheck /> },
    { name: "Main Site", icon: <FaGlobe /> },
    { name: "Resort Booking", icon: <FaBuilding /> },
    { name: "General E-Ticketing", icon: <FaTicketAlt /> },
    { name: "Boating", icon: <FaShip /> },
    { name: "Sightseeing", icon: <FaBinoculars /> },
    { name: "Softwheel Train", icon: <FaTrain /> },
    { name: "Chairlift & Cable Car", icon: <GiCableStayedBridge /> },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].name);

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
    setStep(2); // Move to step 2 after selecting tab
  };

  const onLogin = async (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }
    // console.log("props histore is ", props.history);
    try {
      const data = await LoginApi({ email, password });

      if (data) {
        console.log("login data is ", data);
        
        // Check if user has an allowed role
        const allowedRoles = ["Super Admin", "Admin", "Sub Admin", "Manager"];
        const userRole = data.data?.roles || data.data?.role;
        
        if (!allowedRoles.includes(userRole)) {
          setErrors({
            ...errorObj,
            apiError: `Access denied. Only Super Admin, Admin, Sub Admin, and Manager roles are allowed to log in. Your role: ${userRole || "Unknown"}`,
          });
          return;
        }
        
        const updatedData = {
          ...data.data,
          module: data.module,
        };
        sessionStorage.setItem("userDetails", JSON.stringify(updatedData));
        window.dispatchEvent(new Event("userChanged"));
        props.history.push("/dashboard");
      }
    } catch (err) {
      setErrors({
        ...errorObj,
        apiError: err.message || "Login failed. Please try again.",
      });
    }
    // dispatch(loadingToggleAction(true));
    // dispatch(loginAction(email, password, props.history));
  };

  return (
    <div className="login-main-page">
      <div className="login-wrapper">
        <div className="container h-100">
          <div className="row h-100 align-items-center justify-contain-center">
            <div className="col-xl-12 mt-3">
              <div className="card">
                <div className="card-body p-0">
                  <div className="row m-0">
                    <div className="col-xl-6 col-md-6 sign text-center">
                      <div>
                        <div className="text-center items-center justify-center flex my-5">
                          <Link to="/dashboard">
                            <img
                              width="300"
                              className="mt-3"
                              src={logofull}
                              alt=""
                            />
                          </Link>
                        </div>
                        {/* <img src={logo} className="education-img"></img> */}
                      </div>
                    </div>
                    <div className="col-xl-6 col-md-6">
                      <div className="sign-in-your">
                        {step === 1 && (
                          <>
                            <h4 className="fs-20 font-w800 text-black text-center mb-3">
                              Select Dashboard
                            </h4>
                            <div className="text-center mb-4">
                              <div className="d-inline-flex flex-wrap justify-content-center">
                                {tabs.map((tab, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    className="btn btn-outline-primary mx-2 my-2 d-flex align-items-center justify-content-center"
                                    style={{ minWidth: "40%" }}
                                    onClick={() => handleTabSelect(tab.name)}
                                  >
                                    <span
                                      className="me-2"
                                      style={{ fontSize: "1.2rem" }}
                                    >
                                      {tab.icon}
                                    </span>
                                    {tab.name}
                                  </button>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                        {step === 2 && (
                          <>
                            <div className="mb-3">
                              <button
                                className="btn btn-link text-primary mb-2"
                                onClick={() => setStep(1)}
                              >
                                ← Back
                              </button>
                              <h4 className="fs-20 font-w800 text-black text-center mb-3">
                                Sign in as {activeTab}
                              </h4>
                            </div>

                            {(errors.apiError || props.errorMessage) && (
                              <div
                                className="alert alert-danger text-center py-2"
                                role="alert"
                              >
                                {errors.apiError || props.errorMessage}
                              </div>
                            )}

                            {props.successMessage && (
                              <div
                                className="alert alert-success text-center py-2"
                                role="alert"
                              >
                                {props.successMessage}
                              </div>
                            )}

                            <form onSubmit={onLogin}>
                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Email</strong>
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  value={email}
                                  placeholder="Enter your Email"
                                  onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors.email && (
                                  <div className="text-danger fs-12">
                                    {errors.email}
                                  </div>
                                )}
                              </div>

                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Password</strong>
                                </label>
                                <div className="input-group">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    value={password}
                                    placeholder="Enter your Password"
                                    onChange={(e) => setPassword(e.target.value)}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => setShowPassword(!showPassword)}
                                    tabIndex={-1}
                                  >
                                    <i
                                      className={`bi ${
                                        showPassword ? "bi-eye-slash" : "bi-eye"
                                      }`}
                                    ></i>
                                  </button>
                                </div>
                                {errors.password && (
                                  <div className="text-danger fs-12">
                                    {errors.password}
                                  </div>
                                )}
                              </div>

                              <div className="text-center">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-block"
                                >
                                  Sign Me In
                                </button>
                              </div>
                            </form>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
